import { Buttons } from '../../controls/buttons';
import { Component, inject, linkedSignal, model, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalDialogComponent } from '../../controls/components/advanced/modal-dialog/modal-dialog.component';
import { ControlLabelComponent } from '../../controls/components/internal/control-label/control-label.component';
import { Selectbox } from '../../controls/selectbox';
import { Stakeholder } from 'src/app/stakeholder/models/stakeholder';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface TrackingChangeStakeholderModalResult {
  stakeholderId: number | null;
  comment: string;
}

@Component({
  imports: [Buttons, ControlLabelComponent, FormsModule, ModalDialogComponent, Selectbox],
  templateUrl: './tracking-change-stakeholder-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './tracking-change-stakeholder-modal.component.scss'
})
export class TrackingChangeStakeholderModalComponent {
  private modal = inject(NgbActiveModal);

  stakeholders = model<Stakeholder[]>([]);
  selectedStakeholderId = model<number | null>(null);
  newSelectedStakeholderId = linkedSignal(() => this.selectedStakeholderId());
  comment = signal('');

  ok(): void {
    this.modal.close({
      stakeholderId: this.newSelectedStakeholderId(),
      comment: this.comment()
    } as TrackingChangeStakeholderModalResult);
  }

  cancel(): void {
    this.modal.dismiss();
  }
}
